import React, { useEffect, useState } from "react";
import { Box, Dialog } from "@mui/material";

import styles from "pages/app-page/AppSpot.module.css";
import { useNavigate } from "react-router-dom";
import { RoutesType } from "shared/types/routes/routers-type";
import RuStoreImg from "shared/assets/RuStoreImg";
import GooglePlayImg from "shared/assets/GooglePlayImg";
import UgskLogo from "shared/assets/UgskLogo";

type DeviceType = "ios" | "android" | "desktop" | "unknown" | "";

const STORE_LINKS = {
  ios: "https://apps.apple.com/ru/app/%D1%8E-%D0%B7%D0%B4%D0%BE%D1%80%D0%BE%D0%B2%D1%8C%D0%B5/id6744051740?l",
  android: "https://play.google.com/store/apps/details?id=com.skgaidemobile",
  ruStore: "https://www.rustore.ru/catalog/app/com.skgaidemobile",
};

const getDeviceType = (): DeviceType => {
  if (typeof navigator === "undefined") {
    return "unknown";
  }
  const userAgent = navigator.userAgent.toLowerCase();

  const isAndroid = /android/.test(userAgent);

  const isIOS =
    /iphone|ipad|ipod/.test(userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

  if (isAndroid) {
    return "android";
  }

  if (isIOS) {
    return "ios";
  }

  if (/windows|macintosh|linux/.test(userAgent)) {
    return "desktop";
  }

  return "unknown";
};

export const AppSpot: React.FC = () => {
  const [deviceType, setDeviceType] = useState<DeviceType>("");
  const navigate = useNavigate();
  const [isStoreModalOpen, setIsStoreModalOpen] = useState(false);

  useEffect(() => {
    setDeviceType(getDeviceType());
  }, []);

  useEffect(() => {
    if (deviceType) {
      if (deviceType === "desktop" || deviceType === "unknown") {
        navigate(RoutesType.AppPage);
      } else if (deviceType === "ios") {
        window.location.href = STORE_LINKS.ios;
        return;
      } else if (deviceType === "android") {
        setIsStoreModalOpen(true);
        return;
      }
    }
  }, [deviceType]);

  return (
    <Box className={styles.content}>
      <Box className={styles.border}>
        <UgskLogo />
      </Box>
      {isStoreModalOpen && (
        <Box className={styles.storeContent}>
          <h2 id="store-dialog-title">Скачать приложение</h2>
          <p>Выберите магазин для скачивания приложения «Ю-Здоровье»</p>
          <Box className={styles.storeLinks}>
            <a
              href={STORE_LINKS.android}
              target="_blank"
              rel="noopener noreferrer"
            >
              <GooglePlayImg />
            </a>
            <a
              href={STORE_LINKS.ruStore}
              target="_blank"
              rel="noopener noreferrer"
            >
              <RuStoreImg />
            </a>
          </Box>
        </Box>
      )}
    </Box>
  );
};
